module.exports = __webpack_public_path__ + "img/increase-decrease-line.00e75952.svg";